// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSDescriptionContentTitle/index.less
// module id = 1123
// module chunks = 42